<div>
  <mat-form-field>
    <mat-label>Начните вводить название</mat-label>
    <input matInput [formControl]="filter" autocomplete="off">
  </mat-form-field>

  <mat-dialog-content>
    <div>
      <div class="controls">
        <div class="groups">
          <div *ngFor="let group of filteredGroups$ | async; trackBy: groupTrackByFn; let j=index" class="group">
            <div *ngIf="groupSelected[j].display && group.length > 0">
              <div class="group-name">
                <mat-checkbox
                              (change)="$event ? masterToggle(j) : null"
                              [checked]="groupSelected[j].all"
                              [indeterminate]="groupSelected[j].some"
                ><b>{{ group[0].group }}</b>
                </mat-checkbox>
              </div>
              <div>
                <mat-checkbox *ngFor="let row of group; trackBy: ratingTrackByFn" class="rating"
                              (click)="$event.stopPropagation()"
                              (change)="$event ? toggle(j, row) : null"
                              [checked]="selection.isSelected(row)"
                ><span>{{ row.name }}</span>
                </mat-checkbox>
              </div>
            </div>
          </div>
          <div *ngIf="loading" class="center"><mat-spinner [diameter]="30"></mat-spinner></div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div>
      <button mat-raised-button
              color="primary"
              [disabled]="!isValid"
              (click)="complete()">Выбрать
      </button>
      <button mat-stroked-button
              color="primary"
              (click)="close()">Закрыть
      </button>
      <span class="var-label">
        {{ varLabel }}
      </span>
    </div>
  </mat-dialog-actions>
</div>
